<ion-grid class="ion-no-padding">
  @if (!disabled) {
    <ion-row>
      <ion-col class="search-bar-container">
        <ion-searchbar
          class="ion-no-padding with-border"
          type="text"
          debounce="200"
          show-clear-button="always"
          placeholder="Search for an address"
          (ionInput)="searchInputChanged($event)"
          (ionClear)="clearSearch()"></ion-searchbar>
        @if (searchResults.length > 0) {
          <ion-list class="container-shadow search-result-list">
            @for (result of searchResults; track result) {
              <ion-item lines="none" (click)="selectSearchResult(result)">
                {{ result.description }}
              </ion-item>
            }
          </ion-list>
        }
      </ion-col>
    </ion-row>
  }

  @if (showMap) {
    <ion-row>
      <ion-col>
        <rc-map
          [latitude]="form.controls[locationFormFields.lat].value"
          [longitude]="form.controls[locationFormFields.lng].value"
          [defaultCenter]="defaultMapCenter"
          [zoom]="mapZoom"
          [disablePinchZoom]="disablePinchZoom"></rc-map>
      </ion-col>
    </ion-row>
  }

  @if (form.controls[locationFormFields.formatted_address].value) {
    <ion-row>
      <ion-col class="address ion-no-padding">
        <ion-item [disabled]="disabled" [lines]="disabled ? 'none' : 'full'" color="white">
          <ion-icon slot="start" name="location-outline"></ion-icon>
          <ion-text>{{ form.controls[locationFormFields.formatted_address].value }}</ion-text>
        </ion-item>
      </ion-col>
    </ion-row>
  }
</ion-grid>
